<template>
  <svg
    class="custom-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.1598 7.31917L9.43946 0.119848C9.29954 -0.0400066 9.0399 -0.0400066 8.88003 0.119848L2.15975 7.31917C1.93997 7.55888 2.11976 7.9385 2.43946 7.9385H6.26268V13.5661C6.26268 13.766 6.42254 13.9257 6.62225 13.9257H11.6571C11.857 13.9257 12.0167 13.7658 12.0167 13.5661V7.9385H15.8399C16.1996 7.9385 16.3596 7.55885 16.1598 7.31917ZM18 15.7021V17.7001C18 17.8599 17.8601 17.9997 17.7004 17.9997L0.299637 17.9999C0.139782 17.9999 0 17.8599 0 17.7002V15.7023C0 15.5424 0.139925 15.4026 0.299637 15.4026H17.7203C17.8802 15.4025 18 15.5223 18 15.7021Z"
    />
  </svg>
</template>
